import {
  ChangeDetectionStrategy, ChangeDetectorRef,
  Component,
  EventEmitter,
  Inject, Input,
  OnInit,
  Output, ViewChild
} from "@angular/core";
import {PANEL_DATA} from "../../../../commons/angular/services/panel.service";
import {CdkVirtualScrollViewport} from "@angular/cdk/scrolling";
import {PlanningHttpService} from "../../services/planning-http.service";
import * as _ from "lodash";
import * as moment from "moment";

interface PlanningProjectsSelectListModel {
  selectedProjectId: string;
  // dateRange: { from: number, to: number };
  projects: any[]
}

require('./planning-projects-select-list.scss');
@Component({
  standalone: false,
  selector: 'app-planning-projects-select-list',
  templateUrl: './planning-projects-select-list.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PlanningProjectsSelectListComponent implements OnInit {

  // @Input() projects: any[];
  @Output() onClose = new EventEmitter<any>();

  @ViewChild(CdkVirtualScrollViewport, {static: false})
  private cdkVirtualScrollViewport: CdkVirtualScrollViewport;

  public selectedProjectId: string;
  public dateRange: { from: number, to: number };
  public projects: any[] = [];
  public cursor: string;
  public isFetchingData: boolean;
  public queryString: string;
  public projectsCopy: any[];

  constructor(@Inject(PANEL_DATA) public data: PlanningProjectsSelectListModel,
              @Inject(PlanningHttpService) private planningHttpService: PlanningHttpService, @Inject(ChangeDetectorRef) private cdr: ChangeDetectorRef) {
  }

  ngOnInit() {
    this.selectedProjectId = this.data.selectedProjectId;
    // this.dateRange = this.data.dateRange;
    this.projects = [...this.data.projects || []];
    this.projectsCopy = [...this.projects];
    // this.getProjects();
  }

  onSelect(project: any) {
    this.onClose.emit({selectedProject: project});
  }

  onQueryChange(query) {
    this.queryString = query;
    this.projectsCopy = this.projects.filter(p => p.name.toLowerCase().includes(query.toLowerCase()));
    // this.draftsCopy = this.drafts.filter(draft => draft.name.toLowerCase()?.includes(query.toLowerCase()));
  }

  // getNextBatch() {
  //   if (this.cdkVirtualScrollViewport.measureScrollOffset('bottom') < 50 && !this.isFetchingData && !!this.cursor) {
  //     this.getProjects(this.cursor);
  //   }
  // }
  //
  // getProjects(cursor?: string) {
  //   const params: { cursor?: string, from: number, to: number } = {
  //     from: this.dateRange.from || moment().startOf('day').valueOf(),
  //     to: this.dateRange.to || moment().endOf('day').valueOf(),
  //   };
  //   if (cursor) {
  //     params.cursor
  //   }
  //   this.isFetchingData = true;
  //   this.planningHttpService.getProjects(params).subscribe(
  //     {
  //       next: (res) => {
  //         this.cursor = res.cursor;
  //         this.projects = _.uniqBy([...this.projects, ...res.list], 'id');
  //         this.cdr.detectChanges();
  //         this.isFetchingData = false;
  //       },
  //       error: (error) => {
  //         this.isFetchingData = false;
  //       },
  //       complete: () => {
  //         this.isFetchingData = false;
  //       }
  //     }
  //   )
  // }

}
